const initLocalization = () => {
  if (!customElements.get('localization-form')) {
    customElements.define(
      'localization-form',
      class LocalizationForm extends HTMLElement {
        constructor() {
          super()
          this.elements = {
            input: this.querySelector(
              'input[name="country_code"], input[name="language_code"]'
            ),
          }

          const options = this.querySelectorAll('sl-option')

          options.forEach((item) => {
            item.addEventListener('click', this.onOptionSelect.bind(this))
            item.addEventListener('keydown', (event) => {
              if (event.key === 'Enter') {
                this.onOptionSelect(event)
              }
            })
          })
        }

        onOptionSelect(event) {
          event.stopPropagation()
          const form = this.querySelector('form')
          this.elements.input.value = event.currentTarget.dataset.value
          if (form) form.submit()
        }
      }
    )
  }
}
initLocalization()
